<ng-container *transloco="let t">
    <ng-template #teamMemberName>
        <div>
            <div class="title highlight">{{firstName}} {{lastName}}</div>
            <div class="subtitle highlight">{{t('competitor.table.team.member')}}</div>
        </div>
    </ng-template>
    <ng-template #dayTime>
                <div class="title">{{dayTimeText}}</div>
                <div class="subtitle">{{t('competitor.table.day.time')}}</div>
    </ng-template>
    <ng-template #passTime>
        <div class="d-flex flex-column align-items-end">
            <div class="title highlight">{{passTimeText}}</div>
            <div class="subtitle highlight">{{t("competitor.table.pass.time")}}</div>
            @if (penalty) {
            <div class="tag orange small">+{{penalty}}:00 {{t('competitor.table.penalty.label')}}</div>
            }
        </div>
    </ng-template>
    <ng-template #totalTime>
        <div class="d-flex flex-column align-items-end">
            <div class="title highlight">{{totalTimeText}}</div>
            <div class="subtitle highlight">{{t('competitor.table.time.overall')}}</div>
            @if (showAfterPenaltyNote) {
            <div class="subtitle highlight">({{t('competitor.table.after.penalty')}})</div>
            }
        </div>
    </ng-template>

    <div class="member-row" [class.member-row--determines]="determines">
        <div class="desktop-only-detail">
            <div class="d-flex align-items-center gap-2 member-row__name-block">
                <ng-container *ngTemplateOutlet="teamMemberName"></ng-container>
            </div>
            <div class="d-flex align-items-center gap-4 member-row__stats-desktop">
                <div class="text-end">
                    <ng-container *ngTemplateOutlet="dayTime"></ng-container>
                </div>
                <ng-container *ngTemplateOutlet="passTime"></ng-container>
                <ng-container *ngTemplateOutlet="totalTime"></ng-container>
                <app-ranking-panel
                        [cssClass]="'d-flex gap-4'"
                        [overallRank]="overallRank"
                        [sex]="sex"
                        [sexRank]="sexRank"
                        [categoryRank]="categoryRank"
                />
            </div>
        </div>

        <div class="mobile-only-detail">
            <div class="mb-3">
                    <div class="w-100">
                        <div class="mb-2 d-flex align-items-center justify-content-between">
                            <ng-container *ngTemplateOutlet="teamMemberName"></ng-container>
                            <div class="d-flex gap-4">
                                <ng-container *ngTemplateOutlet="passTime"></ng-container>
                                <ng-container *ngTemplateOutlet="totalTime"></ng-container>
                            </div>
                        </div>
                        <div class="mb-2 d-flex align-items-center justify-content-between">
                                <div class="text-start">
                                    <ng-container *ngTemplateOutlet="dayTime"></ng-container>
                                </div>
                                <app-ranking-panel
                                    [cssClass]="'d-flex w-100 justify-content-end gap-4'"
                                    [overallRank]="overallRank"
                                    [sex]="sex"
                                    [sexRank]="sexRank"
                                    [categoryRank]="categoryRank"
                                />
                        </div>

                    </div>
                </div>
        </div>
    </div>
</ng-container>